import React from 'react';

import { withFirebase } from '../Firebase';
import {Button, Icon} from "semantic-ui-react";

const SignOut = ({ firebase }) => (
    <Button icon labelPosition='left' onClick={firebase.doSignOut}>Abmelden<Icon name={'open lock'}/></Button>
);

export default withFirebase(SignOut);